import { styled } from '@mui/material'
import MuiDialogTitle from '@mui/material/DialogTitle'
import { DialogTitleProps } from './DialogTitle.types'

export const DialogTitle = styled(MuiDialogTitle)<DialogTitleProps>`
  padding: 24px;
`
